var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_6472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1V2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 1V2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 8H19",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_176_6472",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 3.79086 1.79086 2 4 2H16C18.2091 2 20 3.79086 20 6V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4 3.5H16V0.5H4V3.5ZM18.5 6V16H21.5V6H18.5ZM16 18.5H4V21.5H16V18.5ZM1.5 16V6H-1.5V16H1.5ZM4 18.5C2.61929 18.5 1.5 17.3807 1.5 16H-1.5C-1.5 19.0376 0.962434 21.5 4 21.5V18.5ZM18.5 16C18.5 17.3807 17.3807 18.5 16 18.5V21.5C19.0376 21.5 21.5 19.0376 21.5 16H18.5ZM16 3.5C17.3807 3.5 18.5 4.61929 18.5 6H21.5C21.5 2.96243 19.0376 0.5 16 0.5V3.5ZM4 0.5C0.962434 0.5 -1.5 2.96243 -1.5 6H1.5C1.5 4.61929 2.61929 3.5 4 3.5V0.5Z",
    fill: "#197C85",
    mask: "url(#path-4-inside-1_176_6472)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_176_6472",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 13C11 11.8954 11.8954 11 13 11H15C16.1046 11 17 11.8954 17 13V15C17 16.1046 16.1046 17 15 17H13C11.8954 17 11 16.1046 11 15V13Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13 12.5H15V9.5H13V12.5ZM15.5 13V15H18.5V13H15.5ZM15 15.5H13V18.5H15V15.5ZM12.5 15V13H9.5V15H12.5ZM13 15.5C12.7239 15.5 12.5 15.2761 12.5 15H9.5C9.5 16.933 11.067 18.5 13 18.5V15.5ZM15.5 15C15.5 15.2761 15.2761 15.5 15 15.5V18.5C16.933 18.5 18.5 16.933 18.5 15H15.5ZM15 12.5C15.2761 12.5 15.5 12.7239 15.5 13H18.5C18.5 11.067 16.933 9.5 15 9.5V12.5ZM13 9.5C11.067 9.5 9.5 11.067 9.5 13H12.5C12.5 12.7239 12.7239 12.5 13 12.5V9.5Z",
    fill: "#197C85",
    mask: "url(#path-6-inside-2_176_6472)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_6472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAlt);
export default __webpack_public_path__ + "static/media/calendarAlt.cbeccba1e4e190069edb446510cc225e.svg";
export { ForwardRef as ReactComponent };